// extracted by mini-css-extract-plugin
export default {"fieldset":"CollapseApuracao_fieldset__3PZzo","form":"CollapseApuracao_form__dOJoQ","table":"CollapseApuracao_table__AkMr4"};